// extracted by mini-css-extract-plugin
export default {"wrapper":"Radio_wrapper__u62O2","input":"Radio_input__5Y8LT","label":"Radio_label__G-IKn"};